import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { GameStatsModel } from '@app/games/models/game-stats.model';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fairness-result-modal',
  template: `
    <div (click)="close()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <div class="fairness-popup-home">
      <h4 translate [translateParams]="{ user: data.username || '(Anonymous)' }">game_stats.placed_by</h4>
      <p class="date">{{ data.finishedAt | date: 'medium' }}</p>
      <div class="_20px-spacer"></div>

      <a
        class="fairness-game-id-value"
        href="#"
        (click)="close(); $event.preventDefault(); openFairness()"
        data-id="modalFairnessResult-id-value"
        >{{ 'game_stats.game_id' | translate }} {{ data._id }}</a
      >

      <div class="_20px-spacer"></div>
      <div class="fairness-values-div">
        <div>Profit</div>
        <div
          class="fairness-value"
          [ngClass]="{ 'loss-fairness': data.profit < 0, 'profit-fairness': data.profit > 0 }"
        >
          {{ data.profit | crypto: data.currency:'code':false:true }}
        </div>
      </div>
      <div class="fairness-lines"></div>
      <!--
        <div class="fairness-values-div">
          <div translate>game_stats.payout</div>
          <div class="fairness-value">{{ data.payout.toFixed(2) }}x</div>
        </div>
      -->
      <!-- <div class="fairness-lines"></div> -->
      <div class="fairness-values-div">
        <div>Wagered</div>
        <div class="fairness-value">{{ data.bet | crypto: data.currency:'code':false:true }}</div>
      </div>
      <div class="_20px-spacer"></div>
      <app-form-button class="full-width" (click)="openFairness()" data-id="modalFairnessResult-view-button">
        View verification & game info
      </app-form-button>
    </div>
  `,
  styles: [
    `
      :host {
        text-align: center;
      }
      .date {
        font-size: 12px;
        line-height: 16px;
      }
      .fairness-game-id-value {
        width: 100%;
        padding: 5px 10px;
        border-radius: 6px;
        background-color: #59b2e1;
        color: #fff;
        line-height: 24px;
        text-align: center;
        text-decoration: none;
        display: block;
      }
      .fairness-values-div {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        margin-bottom: 5px;
        padding-right: 10px;
        padding-left: 10px;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        color: #fff;
        font-size: 13px;
      }
      .fairness-value {
        margin-left: 20px;
        color: #fff;
        font-size: 16px;
        line-height: 26px;
      }
      .fairness-lines {
        width: 100%;
        height: 1px;
        margin-top: 2px;
        margin-bottom: 2px;
        background-color: hsla(0, 0%, 85%, 0.2);
      }
      .buttons-wrap {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 20px;
      }
      .buttons-wrap app-form-button {
        width: 48%;
      }
    `,
  ],
})
export class FairnessResultModalComponent extends AnimatedModalComponent implements OnInit {
  data: any = null;

  constructor(
    private _ref: NgbActiveModal,
    protected _elRef: ElementRef,
    protected _renderer: Renderer2,
    private router: Router
  ) {
    super(_elRef, _renderer);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public close(): void {
    this._ref.close();
  }

  openFairness() {
    this.close();
    this.router.navigate([{ outlets: { modal: ['fairness', this.data._id] } }]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/fairness-result-modal.component.ts